import { HTMLAttributes } from 'react'
import { cva, VariantProps } from 'class-variance-authority'

import Section from '@/components/base/section'

import { cn } from '@/lib/utils'

const spacerVariants = cva(
  [
    'border-0 bg-transparent',
    'h-0 w-full pb-[15rem]',
    'lg:h-full lg:shrink-0 lg:grow-0 lg:pb-0'
  ],
  {
    variants: {
      variant: {
        gutter: 'pb-gutter lg:w-gutter',
        'col-1': 'lg:w-col-span-1',
        'col-2': 'lg:w-col-span-2',
        'col-3': 'lg:w-col-span-3',
        'col-4': 'lg:w-col-span-4',
        'col-5': 'lg:w-col-span-5',
        'col-6': 'lg:w-col-span-6'
      }
    },
    defaultVariants: {
      variant: 'col-2'
    }
  }
)

export type SpacerProps = HTMLAttributes<HTMLHRElement> &
  VariantProps<typeof spacerVariants>

const Spacer = ({ className, variant, ...props }: SpacerProps) => {
  return (
    <Section
      asChild
      className={cn(spacerVariants({ variant, className }))}
      {...props}
    >
      <hr />
    </Section>
  )
}

export default Spacer
